module.exports = __webpack_public_path__ + "img/11-01_Planning Work.49787df9.svg";